import "./page-advanced-soil-moisture.scss";
import "../../js/core";

$(function () {
  const THRESHOLD = 20;
  class SwipeSlider {
    constructor(slider) {
      this.startX = 0;
      this.oldX = 0;
      this.startPosition = 0;
      this.snapPosition = 0;
      this.isDown = false;
      this.userHasSwiped = false;

      this.cacheElements(slider);
      this.setDimensions();
      this.setIndicator();
      this.bindHandlers();
    }

    cacheElements(slider) {
      this.slider = slider;
      this.items = this.slider.querySelectorAll('.js-slider-item');
      this.indicator = slider.parentNode.querySelector('.js-slider-indicator');
      this.indicatorBar = slider.parentNode.querySelector('.js-slider-indicator-bar');
    }

    setDimensions() {
      const spacing = 20;
      const sliderWidth = this.slider.offsetWidth;
      const itemWidth = this.items[0].offsetWidth;
      const itemsWidth = this.items.length * itemWidth;

      this.itemWidth = itemWidth;
      this.maxAllowedW = sliderWidth < itemsWidth ? sliderWidth - itemsWidth - spacing : 0;
    }

    setIndicator() {
      if (!this.indicator) return;

      const times = (this.items.length * this.itemWidth) / this.slider.offsetWidth;
      const length = this.indicatorBar.offsetWidth / times;

      this.indicator.style.width = `${length}px`;
    }

    calculateBoundaries(position, bounce = true) {
      const bounceMargin = bounce ? this.itemWidth / 4 : 0;

      if (position > bounceMargin) return bounceMargin;
      if (position < this.maxAllowedW - bounceMargin) return this.maxAllowedW - bounceMargin;

      return position;
    }

    calculateNextSnap(position, swipeNext) {
      let snapPosition = (parseInt((position / this.itemWidth), 10) - swipeNext) * this.itemWidth;

      if (snapPosition < this.maxAllowedW) snapPosition = this.maxAllowedW;
      return snapPosition;
    }

    moveIndicator(currPos) {
      if (!this.indicator) return;

      const indicatorPos = this.indicatorBar.offsetWidth - this.indicator.offsetWidth;
      const position = this.mapToRange(currPos, 0, this.maxAllowedW, 0, indicatorPos);

      this.indicator.style.left = `${position}px`;
    }

    moveSlider(position, snapPosition = null) {
      this.snapPosition = snapPosition != null ? snapPosition : position;

      this.slider.setAttribute('style', `transform: translate3d(${position}px, 0, 0)`);
    }

    mapToRange(num, inMin, inMax, outMin, outMax) {
      return ((num - inMin) * (outMax - outMin)) / ((inMax - inMin) + outMin);
    }

    bindHandlers() {
      this.slider.addEventListener('touchstart', (e) => this.handleTouchStart(e));
      this.slider.addEventListener('touchmove', (e) => this.handleTouchMove(e));
      this.slider.addEventListener('touchend', (e) => this.handleEnd(e));

      this.slider.addEventListener('mousedown', (e) => this.handleMouseStart(e));
      this.slider.addEventListener('mousemove', (e) => this.handleMouseMove(e));
      this.slider.addEventListener('mouseup', (e) => this.handleEnd(e));
      this.slider.addEventListener('mouseleave', (e) => this.handleEnd(e));

      this.slider.addEventListener('wheel', (e) => this.handleWheel(e));

      this.slider.addEventListener('click', (e) => this.handleClick(e));
      window.addEventListener('resize', () => this.handleResize());
    }

    handleTouchStart(e) {
      if (e.touches.length > 1) return;

      this.handleStart(e);
    }

    handleMouseStart(e) {
      e.preventDefault();

      this.handleStart(e);
    }

    handleStart(e) {
      this.isDown = true;
      this.userHasSwiped = false;
      this.startPosition = this.snapPosition;
      this.startX = (e.pageX || e.touches[0].pageX) - this.slider.offsetLeft;

      this.slider.classList.add('active');
    }

    handleTouchMove(e) {
      if (e.touches.length > 1 || !this.isDown) return;

      this.handleMove(e);
    }

    handleMouseMove(e) {
      if (!this.isDown) return;

      e.preventDefault();
      this.handleMove(e);
    }

    handleMove(e) {
      const pageX = e.pageX || e.touches[0].pageX;
      const currX = pageX - this.slider.offsetLeft;
      const dist = currX - this.startX;

      if (Math.abs(dist) < THRESHOLD) return;

      const swipeNext = this.oldX - currX < 0 ? 0 : 1;
      const accelerate = this.mapToRange(Math.abs(dist), THRESHOLD, window.innerWidth, 1, 3);
      const position = this.calculateBoundaries(this.startPosition + (dist * accelerate));

      e.preventDefault();

      this.userHasSwiped = true;
      this.oldX = currX;

      this.moveSlider(position, this.calculateNextSnap(position, swipeNext));
      this.moveIndicator(position);
    }

    handleEnd() {
      if (!this.isDown) return;

      this.isDown = false;
      this.slider.classList.remove('active');

      this.moveSlider(this.snapPosition);
      this.moveIndicator(this.snapPosition);
    }


    handleWheel(e) {
      if (Math.abs(e.deltaX) < THRESHOLD) return;

      const step = 40;
      const snapPosition = this.snapPosition + (step * Math.sign(e.deltaX));

      this.slider.classList.add('active');
      this.moveSlider(this.calculateBoundaries(snapPosition, false));
      this.moveIndicator(snapPosition);
    }

    handleArrowClick(e) {
      const direction = e.target.classList.contains('left') ? 1 : -1;
      const position = this.calculateBoundaries(
        this.snapPosition + (direction * this.itemWidth), false
      );

      this.slider.classList.remove('active');
      this.moveSlider(position);
      this.moveIndicator(position);
    }

    handleResize() {
      this.setIndicator();
      this.setDimensions();

      if (this.maxAllowedW > this.snapPosition) {
        this.moveSlider(this.maxAllowedW);
        this.moveIndicator(this.maxAllowedW);
      }
    }

    handleClick(e) {
      if (!this.userHasSwiped) return;

      e.preventDefault();
      this.userHasSwiped = false;
    }
  }

  const sliders = document.querySelectorAll('.slider');
  sliders.forEach((slider) => { new SwipeSlider(slider) });
});

$(function () {
  const scroll = document.querySelector(".scroll");
  var isDown = false;
  var scrollX;
  var scrollLeft;

  // Mouse Up Function
  scroll.addEventListener("mouseup", () => {
    isDown = false;
    scroll.classList.remove("active");
  });

  // Mouse Leave Function
  scroll.addEventListener("mouseleave", () => {
    isDown = false;
    scroll.classList.remove("active");
  });

  // Mouse Down Function
  scroll.addEventListener("mousedown", (e) => {
    e.preventDefault();
    isDown = true;
    scroll.classList.add("active");
    scrollX = e.pageX - scroll.offsetLeft;
    scrollLeft = scroll.scrollLeft;
  });

  // Mouse Move Function
  scroll.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    var element = e.pageX - scroll.offsetLeft;
    var scrolling = (element - scrollX) * 2;
    scroll.scrollLeft = scrollLeft - scrolling;
  });
});